import { CheckCircle } from "lucide-react";

const learningTopics = [
  "Introduction to CAD Automation",
  "CAD APIs (AutoCAD, NXOpen, SolidWorks, Inventor)",
  "API Integration with external applications",
  "Custom tool and command development",
  "Batch processing and workflow automation",
  "Building reusable design libraries"
];

const WhatYouLearn = () => {
  return (
    <section 
      data-testid="what-you-learn-section"
      className="py-20 lg:py-28 bg-[#F8FAFC]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left - Content */}
          <div>
            <h2 
              data-testid="what-you-learn-title"
              className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A] mb-6"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              What You'll Learn
            </h2>
            <p className="text-lg text-[#0F172A]/60 mb-8 max-w-lg">
              Master the essential skills needed to automate CAD workflows and build powerful custom tools.
            </p>

            <div className="space-y-4">
              {learningTopics.map((topic, index) => (
                <div 
                  key={index}
                  data-testid={`learning-topic-${index + 1}`}
                  className="flex items-start gap-3 p-4 bg-white rounded-xl border border-slate-200"
                >
                  <CheckCircle className="w-5 h-5 text-[#06B6D4] mt-0.5 flex-shrink-0" />
                  <span className="text-[#0F172A]/80 font-medium">{topic}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Image */}
          <div className="order-first lg:order-last">
            <img
              src="https://images.pexels.com/photos/716661/pexels-photo-716661.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="CAD Automation Learning"
              data-testid="what-you-learn-image"
              className="w-full h-auto rounded-3xl border border-slate-200"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatYouLearn;
